import React, { FC, ReactElement } from 'react';
import styled from 'styled-components';
import { useBreakpoints } from 'logic/hooks/use-breakpoints';

type props = {
  infoBox?: ReactElement;
};

const UserProfileBody = styled.div`
  display: flex;
  column-gap: 10px;
`;

const UserProfileBodyContent = styled.div`
  min-width: 72%;
  flex: 1;
`;

export const UserProfileBodyWrapper: FC<props> = ({ children, infoBox }) => {
  const { maxTablet } = useBreakpoints();
  return (
    <UserProfileBody>
      <UserProfileBodyContent>{children}</UserProfileBodyContent>
      {infoBox && !maxTablet ? <div>{infoBox}</div> : ''}
    </UserProfileBody>
  );
};
